import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const RightElbowPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [elbowRangeRightMinValues, setElbowRangeRightMinValues] = useState([]);
  const [elbowRangeRightMaxValues, setElbowRangeRightMaxValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let elbow_range_right_min = [];
    let elbow_range_right_max = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      elbow_range_right_min.push(recording.hasOwnProperty("elbow_range_right_min") ? recording.elbow_range_right_min : NaN);
      elbow_range_right_max.push(recording.hasOwnProperty("elbow_range_right_max") ? recording.elbow_range_right_max : NaN);
    });

    setPositions(positions);
    setElbowRangeRightMinValues(elbow_range_right_min);
    setElbowRangeRightMaxValues(elbow_range_right_max);

    return () => {
      setPositions([]);
      setElbowRangeRightMinValues([]);
      setElbowRangeRightMaxValues([]);
    };
  }, [recordings]);

  const rightElbowData = {
    labels: positions,
    datasets: [
      {
        label: t("minimum"),
        data: elbowRangeRightMinValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("maximum"),
        data: elbowRangeRightMaxValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_rightElbowJointRangeGraphic_title")}
        Type={Line}
        data={rightElbowData}
        axisY={t("reports_rightElbowJointRangeGraphic_axisY")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_rightElbowJointRangeDescription_ClinicAndHome")}
      />
    </GraphicContainer>
  );
});

export default RightElbowPlot;
